import httpClient, { paramsToString } from '@/services/http/httpClient'

export const apiPostPdfMaterial = (sinisterId, mail) => {
  return httpClient
    .post(`pdf/material`, {
      mail,
      sinister_id: sinisterId
    })
    .then(data => data)
}

export const apiGetPdfMaterial = sinisterId => {
  const params = new URLSearchParams()
  params.append('sinister_id', sinisterId)
  return httpClient
    .get(`pdf/material${paramsToString(params)}`)
    .then(data => data)
}

export const apiGetPdfReport = (sinisterId, repairType) => {
  const params = new URLSearchParams()
  params.append('sinister_id', sinisterId)
  return httpClient
    .get(`pdf/damages/${repairType}${paramsToString(params)}`)
    .then(data => data)
}

export const apiGetSmartReport = (sinisterId) => {
  const params = new URLSearchParams()
  params.append('sinister_id', sinisterId)
  return httpClient
    .get(`/fnol/report${paramsToString(params)}`)
    .then(data => data)
}

export const apiGetPdfReportFnol = sinisterId => {
  const params = new URLSearchParams()
  params.append('sinister_id', sinisterId)
  return httpClient
    .get(`pdf/damages/fnol${paramsToString(params)}`)
    .then(data => data)
}
